<div *ngIf="!listIsClose" class="list-item" (click)="onItemClicked()">
  <div>
    <img [src]="listItem.image" alt="">
  </div>
  <div>{{ listItem.listItemText }}</div>
</div>
